import { SilverItem } from '../types';

/**
 * Calculate cost per unit for silver items based on weight and cost per gram
 */
export const calculateCostPerUnit = (
  item: Partial<SilverItem> & { weight: number }
): number => {
  if (item.costPerGram !== undefined) {
    return Number((item.costPerGram * item.weight).toFixed(2));
  }
  return item.costPerUnit || 0;
};

/**
 * Calculate sell price per unit for silver items based on weight and price per gram
 */
export const calculateSellPerUnit = (
  item: Partial<SilverItem> & { weight: number }
): number => {
  if (item.pricePerGram !== undefined) {
    return Number((item.pricePerGram * item.weight).toFixed(2));
  }
  return item.sellPerUnit || 0;
};

/**
 * Format price with Turkish Lira symbol
 */
export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
}; 